import { FC } from 'react';
import styles from './index.less';

/**
 * SPP 品牌全屏 loading —— 自研，替换 @credit/tips 的全屏 loading。
 * 全屏 #f8f8f8 遮罩(挡交互) + 居中品牌 GIF。
 * 后续要扩展(文案 / 进度 / 多状态等)在此加 props 即可，DOM 完全自主。
 */
const BrandLoading: FC = () => {
  return (
    <div className={styles.mask}>
      <img className={styles.gif} src={require('@/assets/loading.gif')} alt="" />
    </div>
  );
};

export default BrandLoading;
